module.exports = "/_next/static/images/game-1-phone-attachment-lillies-uv-ab6db4eb0d5f965b8642d6f89e9555bf.jpg";